import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotBoard from "./components/HotBoard";
import TimelineFeature from "./components/TimelineFeature";
import EventGrid from "./components/EventGrid";
import Method from "./components/Method";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <HotBoard />
        <TimelineFeature />
        <EventGrid />
        <Method />
        <Faq />
      </main>
      <Footer />

      {/* back to top */}
      <a
        href="#top"
        aria-label="回到顶部"
        className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-soft transition-colors hover:bg-primary-600 cursor-pointer"
      >
        <i className="ri-arrow-up-line text-lg" />
      </a>
    </div>
  );
}